import { action } from "typesafe-actions";
import { SettingActionTypes } from "./setting.model";

export const fetchSettingsRequest = (req) => action(SettingActionTypes.FETCH_SETTINGS_REQUEST, req);
export const fetchSettingsSuccess = (res) => action(SettingActionTypes.FETCH_SETTINGS_SUCCESS, res);
export const fetchSettingsFailure = (err) => action(SettingActionTypes.FETCH_SETTINGS_FAILURE, err);

export const updateSettingRequest = (req) => action(SettingActionTypes.UPDATE_SETTING_REQUEST, req);
export const updateSettingSuccess = (res) => action(SettingActionTypes.UPDATE_SETTING_SUCCESS, res);
export const updateSettingFailure = (err) => action(SettingActionTypes.UPDATE_SETTING_FAILURE, err);




